import type { GameState, Player, Team, HoleInfo, HoleScore, NassauStatus, BetStakes } from './golfEngine';

const PARS = [4, 3, 5, 4, 4, 3, 4, 5, 4, 4, 3, 5, 4, 4, 3, 4, 5, 4];
const STROKE_INDEXES = [7, 15, 3, 1, 11, 17, 5, 9, 13, 8, 16, 4, 2, 12, 18, 6, 10, 14];
const YARDAGES = [410, 175, 530, 445, 390, 165, 420, 510, 385, 430, 180, 545, 450, 395, 160, 415, 520, 400];

const players: Player[] = [
  { id: 'p1', name: 'Alice', handicap: 10, courseHandicap: 11, strokesReceived: 11, teeBoxId: 'tb1' },
  { id: 'p2', name: 'Bob', handicap: 15, courseHandicap: 16, strokesReceived: 16, teeBoxId: 'tb1' },
  { id: 'p3', name: 'Charlie', handicap: 8, courseHandicap: 9, strokesReceived: 9, teeBoxId: 'tb1' },
  { id: 'p4', name: 'Diana', handicap: 12, courseHandicap: 13, strokesReceived: 13, teeBoxId: 'tb1' },
];

const teams: Team[] = [
  { id: 'team1', players: [players[0], players[1]] },
  { id: 'team2', players: [players[2], players[3]] },
];

const holes: HoleInfo[] = PARS.map((par, i) => ({
  number: i + 1,
  par,
  strokeIndex: STROKE_INDEXES[i],
  yardage: YARDAGES[i],
}));

function createParDefaultedScores(): HoleScore[] {
  const scores: HoleScore[] = [];
  for (const player of players) {
    for (const hole of holes) {
      scores.push({
        playerId: player.id,
        holeNumber: hole.number,
        grossScore: hole.par,
        netScore: hole.strokeIndex <= player.strokesReceived ? hole.par - 1 : hole.par,
        receivesStroke: hole.strokeIndex <= player.strokesReceived,
      });
    }
  }
  return scores;
}

const nassauStatus: NassauStatus = { front: 0, back: 0, overall: 0 };
const stakes: BetStakes = { front: 5, back: 5, overall: 5 };

export const MOCK_GAME_STATE: GameState = {
  gameType: 'nassau',
  matchFormat: '2v2',
  gameMode: 'TwoDownAuto',
  teams,
  holes,
  scores: createParDefaultedScores(),
  presses: [],
  nassauStatus,
  currentHole: 1,
  topSideOverallPressUsed: false,
  bottomSideOverallPressUsed: false,
  stakes,
  startingHole: 1,
  isFinalized: false,
};

export const MOCK_PLAYERS = players;
export const MOCK_TEAMS = teams;
export const MOCK_HOLES = holes;
